/**
 * "Relatórios" na barra lateral (REPORTS-03): um link só, para a página em abas
 * (Agora, Caminho, A IA, Equipe, Canais e times, e Carrinhos na conta com a
 * flag). Sem filhos, ele não colapsa; a folha herda a permissão e a flag da rota
 * (`SidebarGroup.vue`, `resolvePermissions`/`resolveFeatureFlag`).
 *
 * `activeOn` lista todo nome de rota de `reports.routes.js`: rota com redirect
 * nunca vira `route.name`, e Etiquetas, CSAT e Robôs, abertos por link, também
 * são Relatórios. O spec confere a lista contra o arquivo de rotas, lido como
 * texto, para não trazer as rotas para o bundle da barra lateral.
 *
 * Mora aqui, e não solto no `computed` de `Sidebar.vue`, para o spec alcançar a
 * declaração inteira — a lição do `powerAppMenu`.
 */
export const REPORT_ROUTE_NAMES = [
  'account_atendimento_reports',
  'account_overview_reports',
  'conversation_reports',
  'account_cart_reports',
  'account_analytics_reports',
  'agent_reports',
  'inbox_reports',
  'label_reports',
  'team_reports',
  'agent_reports_index',
  'agent_reports_show',
  'inbox_reports_index',
  'inbox_reports_show',
  'team_reports_index',
  'team_reports_show',
  'label_reports_index',
  'label_reports_show',
  'csat_reports',
  'bot_reports',
];

/**
 * @param {Object} options
 * @param {Function} options.t - o `t` do vue-i18n
 * @param {Function} options.accountScopedRoute - de `useAccount`
 * @returns {Object} o item de menu Relatórios
 */
export function buildReportsGroup({ t, accountScopedRoute }) {
  return {
    name: 'Reports',
    label: t('SIDEBAR.REPORTS'),
    icon: 'i-lucide-chart-spline',
    to: accountScopedRoute('account_atendimento_reports'),
    activeOn: REPORT_ROUTE_NAMES,
  };
}
